import React, {useEffect, useState } from "react"; 
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';   
import PlaySound from "../PlaySound"
import "../quizAssets.css"
const ViewAsset = ({ isShow,close, viewAssetID,ViewAssetName }) => {   
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => { 
    setShow(isShow)
    setIsLoading(true) 
  }, [viewAssetID,isShow]); 
  return ( 
    <Modal show={show} onHide={handleClose} backdrop="static"   >
        <Modal.Header closeButton>
        <h5 className="modal-title">Asset</h5>
        </Modal.Header>
        <Modal.Body>  
        <form className="row g-3">
              <div className="col-12 px-3">
                <label htmlFor="viewSystemUserName" className="form-label">Asset Name : {ViewAssetName} </label>
                 <span id="viewSystemUserName"></span>
              </div>
              <div className="col-12 px-3">
                <label htmlFor="viewSystemUserEmail" className="form-label" >Asset Preview:  </label>
                <span id="viewSystemUserEmail"></span> 
                <PlaySound assetId={viewAssetID} />
              </div> 

            </form> 
        </Modal.Body>
        <Modal.Footer>     
          {isLoading && <div className="progress-bar"></div>}
       </Modal.Footer>
      </Modal>
       
  );
};

export default ViewAsset;
 